import { unparse as convertToCSV } from "papaparse/papaparse.min";
import moment from "moment";

export const exporter = (records, fetchRelatedRecords) => {
	records = records.filter((record, index) => index < 6000);
	Promise.all(records.map(async (record) => {
		return {
			username: record.username,
			email: record.email,
			firstname: record.firstname,
			lastname: record.lastname,
			mobile: record.mobile,
			lastActive: record.lastActive ? moment(record.lastActive).format("YYYY-MM-DD HH:mm:ss") : ""
		};
	})).then(data => {
		const csv = convertToCSV({
			data,
			fields: ["username", "email", "firstname", "lastname", "mobile", "lastActive"] 
		});
		csvDownload(csv, "user");
	});
};

const csvDownload = (csv, filename) => {
	const fakeLink = document.createElement("a");
	fakeLink.style.display = "none";
	document.body.appendChild(fakeLink);
	const blob = new Blob(["\uFEFF" + csv], { type: "text/csv" });
	if (window.navigator && window.navigator.msSaveOrOpenBlob) {
		// Manage IE11+ & Edge
		window.navigator.msSaveOrOpenBlob(blob, `${filename}.csv`);
	} else {
		fakeLink.setAttribute("href", URL.createObjectURL(blob));
		fakeLink.setAttribute("download", `${filename}.csv`);
		fakeLink.click();
	}
};


// WEBPACK FOOTER //
// ./src/components/user/exporter.js